<template>
  <div class="trial-container">
    <div class="acdsx">
      <!-- <img src="../../assets/clickFree.png" alt=""> -->
      <p>网站正在升级维护中，可点击下方按钮进行试用！</p>
      <div class="clickfree" @click="gommsy">点击试用</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrialPage",
  data() {
    return {};
  },
  methods: {
     gommsy() {
      this.$router.push({ name: "freeTrial" });
    },
  },
};
</script>

<style lang="scss" scoped>
.trial-container {
  font-family: "Microsoft YaHei", sans-serif;
}

.acdsx {
  width: 1920px;
  height: 918px;
  background-image: url("../../assets/clickFree.png");
  background-repeat: no-repeat; /* 防止背景图重复 */
  background-size: cover; /* 背景图自适应容器大小 */
  background-position: center; /* 背景图居中显示 */
  position: relative;
}
p {
  font-weight: 400;
  font-size: 32px;
  color: #000000;
  position: absolute;
  font-weight: bold; /* 加粗（也可写 700，效果一致） */
  font-style: italic; /* 倾斜 */
  top: 690px;
  left: 635px;
}
.clickfree {
  padding: 11px 31px;
  position: absolute;
  top: 767px;
  left: 902px;
  font-weight: 400;
  font-size: 32px;
  color: #317afa;
  font-weight: bold; /* 加粗（也可写 700，效果一致） */
  font-style: italic; /* 倾斜 */
  &:hover {
    background: #317afa;
    border-radius: 32px 32px 32px 32px;
    border: 1px solid #317afa;
    color: #ffffff;
  }
}
</style>